import React from 'react'
import { graphql, StaticQuery } from 'gatsby'

import none from './none'
import normal from './normal'
import explicit from './explicit'

const map = {
  none,
  normal,
  explicit,
}

const CookieMapper = ({ initialTrack, pageId, data }) => {
  const {
    _id,
    companyId,
    cookieOverlay,
  } = data.campaignData

  const {
    layout,
    text,
    linkTitle,
    linkUrl,
    acceptButtonText,
    declineButtonText,
  } = cookieOverlay

  const Cookie = map[layout]

  // second condition prevents cookie overlay from showing in SSR
  // prevents flickering
  if (Cookie && typeof window !== `undefined`) {
    return (
      <Cookie
        campaignId={_id}
        companyId={companyId}
        page={pageId}
        initialTrack={initialTrack}

        text={text}
        linkTitle={linkTitle}
        linkUrl={linkUrl}
        acceptButtonText={acceptButtonText}
        declineButtonText={declineButtonText}
      />
    )
  }

  return null

}

export default (props) => (
  <StaticQuery
    query={graphql`
      query {
        campaignData {
          _id
          companyId
          cookieOverlay {
            layout
            text
            linkTitle
            linkUrl
            acceptButtonText
            declineButtonText
          }
        }
      }
    `}
    render={data => <CookieMapper data={data} {...props} />}
  />
)
